import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { guardaSoSuperAdmin } from 'dashboard/helper/soSuperAdmin';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import { frontendURL } from '../../../helper/URLHelper';

const CaptainPageRouteView = () => import('./pages/CaptainPageRouteView.vue');
const AssistantsIndexPage = () => import('./pages/AssistantsIndexPage.vue');
const AssistantEmptyStateIndex = () => import('./assistants/Index.vue');
const AssistantSettingsIndex = () =>
  import('./assistants/settings/Settings.vue');
const AssistantInboxesIndex = () => import('./assistants/inboxes/Index.vue');
const AssistantPlaygroundIndex = () =>
  import('./assistants/playground/Index.vue');
const AssistantGuardrailsIndex = () =>
  import('./assistants/guardrails/Index.vue');
const AssistantGuidelinesIndex = () =>
  import('./assistants/guidelines/Index.vue');
const AssistantAutomationIndex = () =>
  import('./assistants/automation/Index.vue');
const AssistantHoursIndex = () => import('./assistants/hours/Index.vue');
const AssistantCobrancaIndex = () => import('./assistants/cobranca/Index.vue');
const AssistantAvisosIndex = () => import('./assistants/avisos/Index.vue');
const AssistantPerguntasIndex = () =>
  import('./assistants/perguntas/Index.vue');
const IdentidadeIndex = () => import('./identidade/Index.vue');
const FichasIndex = () => import('./fichas/Index.vue');
const ProvedoresIndex = () => import('./provedores/Index.vue');
const BibliotecaIndex = () => import('./biblioteca/Index.vue');
const RegrasDeEnvioIndex = () => import('./regrasDeEnvio/Index.vue');
const AssistantNotificationsIndex = () =>
  import('./assistants/notifications/Index.vue');
const AssistantMediaIndex = () => import('./assistants/media/Index.vue');
const AssistantHistoricoIndex = () =>
  import('./assistants/historico/Index.vue');
const AssistantPessoaIndex = () => import('./assistants/pessoa/Index.vue');
const AssistantWizardIndex = () => import('./assistants/wizard/Index.vue');
const AssistantPanelIndex = () => import('./assistants/panel/Index.vue');
const AssistantObservabilityIndex = () =>
  import('./assistants/observability/Index.vue');
const AssistantScenariosIndex = () =>
  import('./assistants/scenarios/Index.vue');
const DocumentsIndex = () => import('./documents/Index.vue');
const ResponsesIndex = () => import('./responses/Index.vue');
const ResponsesPendingIndex = () => import('./responses/Pending.vue');
const CustomToolsIndex = () => import('./tools/Index.vue');

const meta = {
  permissions: ['administrator', 'agent'],
  featureFlag: FEATURE_FLAGS.CAPTAIN,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

const metaCustomTools = {
  permissions: ['administrator', 'agent'],
  featureFlag: FEATURE_FLAGS.CAPTAIN_CUSTOM_TOOLS,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

const metaV2 = {
  permissions: ['administrator', 'agent'],
  featureFlag: FEATURE_FLAGS.CAPTAIN_V2,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

const assistantRoutes = [
  {
    path: frontendURL('accounts/:accountId/lumos/:assistantId/faqs'),
    component: ResponsesIndex,
    name: 'captain_assistants_responses_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/lumos/:assistantId/documents'),
    component: DocumentsIndex,
    name: 'captain_assistants_documents_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/lumos/:assistantId/tools'),
    component: CustomToolsIndex,
    name: 'captain_tools_index',
    meta: metaCustomTools,
  },
  {
    path: frontendURL('accounts/:accountId/lumos/:assistantId/scenarios'),
    component: AssistantScenariosIndex,
    name: 'captain_assistants_scenarios_index',
    meta: metaV2,
  },
  {
    path: frontendURL('accounts/:accountId/lumos/:assistantId/playground'),
    component: AssistantPlaygroundIndex,
    name: 'captain_assistants_playground_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/lumos/:assistantId/inboxes'),
    component: AssistantInboxesIndex,
    name: 'captain_assistants_inboxes_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/lumos/:assistantId/faqs/pending'),
    component: ResponsesPendingIndex,
    name: 'captain_assistants_responses_pending',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/lumos/:assistantId/settings'),
    component: AssistantSettingsIndex,
    name: 'captain_assistants_settings_index',
    meta,
  },
  // Settings sub-pages (guardrails and guidelines)
  {
    path: frontendURL(
      'accounts/:accountId/lumos/:assistantId/settings/guardrails'
    ),
    component: AssistantGuardrailsIndex,
    name: 'captain_assistants_guardrails_index',
    meta: metaV2,
  },
  {
    path: frontendURL(
      'accounts/:accountId/lumos/:assistantId/settings/guidelines'
    ),
    component: AssistantGuidelinesIndex,
    name: 'captain_assistants_guidelines_index',
    meta: metaV2,
  },
  {
    path: frontendURL(
      'accounts/:accountId/lumos/:assistantId/settings/automation'
    ),
    component: AssistantAutomationIndex,
    name: 'captain_assistants_automation_index',
    meta: metaV2,
  },
  // A Andie do Financeiro se configura aqui, com as outras IAs: a régua das
  // etapas, os limites e a chave. Ver `CobrancaConfiguracao`.
  {
    path: frontendURL(
      'accounts/:accountId/lumos/:assistantId/settings/cobranca'
    ),
    component: AssistantCobrancaIndex,
    name: 'captain_assistants_cobranca_index',
    meta: metaV2,
  },
  // O agente do cliente se configura aqui: o aviso de que o processo andou e o explicador
  // do andamento (18/10/2026). A aprovação fica no Jurídico. Ver `ConfiguracaoDoAviso`.
  {
    path: frontendURL(
      'accounts/:accountId/lumos/:assistantId/settings/avisos-ao-cliente'
    ),
    component: AssistantAvisosIndex,
    name: 'captain_assistants_avisos_index',
    meta: metaV2,
  },
  // O agente de processos responde "como está o meu processo?" (18/10/2026). Ver
  // `ConfiguracaoDasPerguntas`.
  {
    path: frontendURL(
      'accounts/:accountId/lumos/:assistantId/settings/perguntas-sobre-processo'
    ),
    component: AssistantPerguntasIndex,
    name: 'captain_assistants_perguntas_index',
    meta: metaV2,
  },
  {
    path: frontendURL('accounts/:accountId/lumos/:assistantId/settings/hours'),
    component: AssistantHoursIndex,
    name: 'captain_assistants_hours_index',
    meta: metaV2,
  },
  {
    path: frontendURL(
      'accounts/:accountId/lumos/:assistantId/settings/notifications'
    ),
    component: AssistantNotificationsIndex,
    name: 'captain_assistants_notifications_index',
    meta: metaV2,
  },
  // Quem mudou o quê no agente, quando (fatia 1a). Só administrador.
  {
    path: frontendURL(
      'accounts/:accountId/lumos/:assistantId/settings/historico'
    ),
    component: AssistantHistoricoIndex,
    name: 'captain_assistants_historico_index',
    meta: metaV2,
  },
  {
    path: frontendURL('accounts/:accountId/lumos/:assistantId/settings/media'),
    component: AssistantMediaIndex,
    name: 'captain_assistants_media_index',
    meta: metaV2,
  },
  // Quando chamar uma pessoa: as frases do escritório somadas às regras fixas
  // (Lumos::PedidoDeHumano). Vale para a conta inteira; mora aqui porque é
  // onde se configura o atendimento.
  {
    path: frontendURL('accounts/:accountId/lumos/:assistantId/settings/pessoa'),
    component: AssistantPessoaIndex,
    name: 'captain_assistants_pessoa_index',
    meta: metaV2,
  },
  {
    path: frontendURL('accounts/:accountId/lumos/wizard'),
    component: AssistantWizardIndex,
    name: 'captain_assistants_wizard_index',
    meta: metaV2,
  },
  {
    path: frontendURL('accounts/:accountId/lumos/painel'),
    component: AssistantPanelIndex,
    name: 'captain_assistants_panel_index',
    meta: metaV2,
  },
  {
    path: frontendURL('accounts/:accountId/lumos/observabilidade'),
    component: AssistantObservabilityIndex,
    name: 'captain_assistants_observability_index',
    meta: metaV2,
  },
  {
    path: frontendURL('accounts/:accountId/lumos/identidade'),
    name: 'captain_identidade_index',
    component: IdentidadeIndex,
    meta: { permissions: ['administrator'] },
  },
  {
    // O QUE A ANDIE PODE AFIRMAR em cada área, assinado pelo advogado.
    // Nível da conta, como a identidade: o fato é do escritório, não de um
    // assistente. Ver Lumos::FichaDeFato.
    path: frontendURL('accounts/:accountId/lumos/fichas'),
    name: 'captain_fichas_index',
    component: FichasIndex,
    meta: { permissions: ['administrator'] },
  },
  {
    // QUAL IA ATENDE CADA PONTO — só leitura; a Andie troca na tela dela,
    // os outros pontos no super admin.
    path: frontendURL('accounts/:accountId/lumos/provedores'),
    name: 'captain_provedores_index',
    component: ProvedoresIndex,
    meta: { permissions: ['administrator'] },
    // Só o super admin (18/10/2026): o escritório não vê qual IA o Lumos usa.
    beforeEnter: guardaSoSuperAdmin,
  },
  {
    // A BIBLIOTECA CURADA DA IA (fatia 6.2, 28/10/2026): só exemplo aprovado por
    // quem o escritório marcou entra na instrução. Quem está marcado pode não ser
    // administrador: a rota abre para os dois e o servidor confere quem é.
    path: frontendURL('accounts/:accountId/lumos/biblioteca'),
    name: 'captain_biblioteca_index',
    component: BibliotecaIndex,
    meta: { permissions: ['administrator', 'agent'] },
  },
  {
    // QUANDO E QUANTO O ADVUP MANDA SOZINHO (18/10/2026): horário geral, feriados e limites
    // de toda mensagem automática. Moravam em Follow-up › Configurações.
    path: frontendURL('accounts/:accountId/lumos/regras-de-envio'),
    name: 'captain_regras_de_envio_index',
    component: RegrasDeEnvioIndex,
    meta: { permissions: ['administrator'] },
  },
  {
    path: frontendURL('accounts/:accountId/lumos/assistants'),
    component: AssistantEmptyStateIndex,
    name: 'captain_assistants_create_index',
    meta: {
      permissions: ['administrator', 'agent'],
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
  },
  {
    path: frontendURL('accounts/:accountId/lumos/:navigationPath'),
    component: AssistantsIndexPage,
    name: 'captain_assistants_index',
    meta,
  },
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/lumos'),
    component: CaptainPageRouteView,
    redirect: to => {
      return {
        name: 'captain_assistants_index',
        params: {
          navigationPath: 'captain_assistants_responses_index',
          ...to.params,
        },
      };
    },
    children: [...assistantRoutes],
  },
];
